import { useSearchParams } from "react-router-dom"

import { decodeParams } from "@/organisms/Drawers/applications/common/common"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"
import { ViolationsList } from "./ViolationsList"

// The drawer's policy, read from the url once the drawer has it: nothing is
// asked for before
export const ViolationLog = ({ drawerId }: { drawerId: string }) => {
  const [searchParams] = useSearchParams()
  const encoded = searchParams.get(drawerId)
  const policyId = encoded ? decodeParams(encoded)?.record.id : undefined
  const { findById } = useAiPolicies()

  if (!policyId) return null

  const policy = findById(policyId)

  return (
    <ViolationsList
      policyId={policyId}
      policy={policy && policy.type !== "heading" ? policy : undefined}
    />
  )
}
